import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { sync } from 'vuex-router-sync'

import BootstrapVue from 'bootstrap-vue'
import VeeValidate from 'vee-validate'
import JsonExcel from 'vue-json-excel'
import VueMuuri from 'vue-muuri'
import * as Sentry from '@sentry/vue'
// eslint-disable-next-line import/no-unresolved
// TODO: Is this unused? Can we delete?
// import Result from '@microbadevs/report'
import i18n from '@/lib/language-pack'
import VueI18n from 'vue-i18n'
import messages from '@/i18n.json'
import store from '@/stores/index.js'
import Bus from '@/event'
import VueTelInput from 'vue-tel-input'
import 'vue-muuri/dist/vue-muuri.css'

import 'sweetalert2/src/sweetalert2.scss'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './registerFontAwesomeLibrary.js'

import FeatureToggleService from '@/services/featureToggleService'

const SENTRY_AUTH_TOKEN = process.env.VUE_APP_SENTRY_AUTH_TOKEN
const APP_API_ROOT = process.env.VUE_APP_API_ROOT
const APP_HCP_JOURNEY_URL = process.env.VUE_APP_HCP_JOURNEY_URL
const APP_REPORT_SERVICE_URL = process.env.VUE_APP_REPORT_SERVICE_URL

if (SENTRY_AUTH_TOKEN) {
  Sentry.init({
    Vue,
    dsn: 'https://0e7dfd9fc4464f0c9f8303ece32d3aa0@o287399.ingest.sentry.io/1527783',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      }),
      new Sentry.Replay()
    ],
    sampleRate: 0,
    tracesSampleRate: 0,
    tracePropagationTargets: [
      'localhost',
      new RegExp(`^${APP_API_ROOT}`),
      new RegExp(`^${APP_HCP_JOURNEY_URL}`),
      new RegExp(`^${APP_REPORT_SERVICE_URL}`)
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('downloadExcel', JsonExcel)
Vue.use(Bus)
Vue.use(BootstrapVue)
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
Vue.use(VueI18n)
// Vue.use(Result)
Vue.use(VueMuuri)
Vue.use(VueTelInput)
FeatureToggleService.init()

Vue.config.productionTip = false

Vue.prototype.$appName = 'Microba'

// Add i18n messages to the existing i18n instance
i18n.setLocaleMessage('en', messages.en)

sync(store, router)

Vue.filter('percentage', function (value, decimals) {
  if (!value) value = 0
  if (!decimals) decimals = 0

  value = value * 100
  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) + '%'
})
localStorage.setItem('API_ROOT', process.env.VUE_APP_API_ROOT)
/* eslint-disable no-new */
new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app')

console.log('staff portal from frontend/apps')
